import {
  createRoutesFromChildren,
  matchRoutes,
  Routes,
  useLocation,
  useNavigationType,
} from 'react-router-dom';
import {
  initializeFaro,
  createReactRouterV7Options,
  ReactIntegration,
  getWebInstrumentations,
} from '@grafana/faro-react';
import { TracingInstrumentation } from '@grafana/faro-web-tracing';
import { nodeEnv, urlFaro } from '@/shared/constants';
import pkg from '../package.json';
import { isNullOrEmptyOrUndefined } from '@c360/shared';

// Faro is disabled unless a collector URL is configured (VITE_FARO_URL in
// Doppler). Clearing the secret turns instrumentation off; setting it back on
// re-enables it — no separate flag to keep in sync with the URL.
if (!isNullOrEmptyOrUndefined(urlFaro)) {
  console.log(`Faro instrumentation is enabled. Collector URL: ${urlFaro}`);
  initializeFaro({
    url: urlFaro,
    app: {
      name: 'CXVH',
      version: pkg.version,
      environment: nodeEnv.startsWith('p')
        ? 'production'
        : nodeEnv.startsWith('s')
          ? 'staging'
          : 'development',
    },

    instrumentations: [
      // Mandatory, omits default instrumentations otherwise.
      ...getWebInstrumentations(),

      // Tracing package to get end-to-end visibility for HTTP requests.
      new TracingInstrumentation(),

      // React integration for React applications.
      new ReactIntegration({
        router: createReactRouterV7Options({
          createRoutesFromChildren,
          matchRoutes,
          Routes,
          useLocation,
          useNavigationType,
        }),
      }),
    ],
  });
}else{
  console.debug('Faro instrumentation is disabled because no collector URL is configured.');
}
